<template lang="pug">
    .filters
        el-alert(
            v-if="!options.filter.items.length"
            type="warning"
            :title="$t('This category has no filter options.')"
            effect="dark"
            :closable="false"
        )
        FilterValueInput(
            v-else
            v-for="filter in options.filter.items"
            :key="filter.id"
            :relatedFilter="filter"
        )
</template>

<i18n>
{
    "de": {
        "This category has no filter options.": "Diese Kategorie hat keine Filteroptionen."
    }
}
</i18n>

<script>

import _ from 'lodash';

import FilterValueInput from './Partials/Filter.vue';
// import { adminClient as apolloClient } from '@/store/apollo';
import CategoryFiltersAPI from '@/store/api/cms/categoryFilter';
import { usePageStore } from '@/stores';

export default {
    name: "Filters",
    components: {
        FilterValueInput
    },
    computed: {
        pageStore() {
            return usePageStore();
        },
        options() {
            return this.pageStore.options;
        }
    },
    mounted() {
        // this.fetchFilters();
    }
}
</script>
<style lang="sass" scoped>
    .filters
        ::v-deep section:last-of-type
            .tag-row
                .el-form-item
                    margin-bottom: 0
</style>
